module.exports = __webpack_public_path__ + "static/media/open-in-browser-2.5be60201.png";